<template>
	<div>
		<div class="login-head fc-bet container">
			<div class="fc">
				<a href="" class="logo fc" v-if="false">
					<img src="@/assets/logo.jpg" alt="" srcset="">
				</a>
				<div class="login-title">
					重置密码
				</div>
			</div>
			<div class="login-right-logo reg-right-logo fc">
				<router-link to="login">
					登录
				</router-link>
			</div>
		</div>
		<div class="register-container">
			<div class="personal-register">
				<form action="" class="form">
					<div class="form-group">
						<div class="tips">
							<span class="require">*</span>手机号
						</div>
						<input type="tel" class="input" placeholder="请输入手机号" v-model="phone">
						<!-- <div class="tip err" v-if="!phone">
							手机号码不能为空
						</div> -->
					</div>
					<div class="form-group">
						<div class="tips">
							<span class="require">*</span>验证码
						</div>
						<input type="text" class="input sms" placeholder="请输入验证码" v-model="code">
						<div class="btn-send-code" v-if="showSendSms">
							<ge-code :config="config"></ge-code>
						</div>
						<div class="btn-send-code" v-else>
							获取短信验证码
						</div>
						<div class="tip err">
						</div>
					</div>
					<div class="form-group">
					          <button type="button" class="btn" id="registerBtn" @click="register(3);">重置密码</button>
					</div>
				</form>
			</div>
		</div>
		<i-footer></i-footer>
	</div>
</template>

<script>

	import geCode from 'vue-gecode'
  import {getResetPwdSend, getResetPwdSendConfirm, getVerify} from "@/api/login";
	export default {
		components: {
			geCode
		},

		data() {
			return {
				stepActive:1,
				phone: null,//收件好
        code: null,//验证码
        recommendationCode: null,
				password: "",
        repassword: "",
				pwd_hide: true,
				config: {
					//开始时候的文本
					startText: '获取短信验证码',
					//获取验证码结束后文本
					endText: '再次获取',
					//验证码倒计时总时间(秒)
					totalTime: 60,
					//验证码每次隔多久变一次(秒)
					tickTime: 1,
					//倒计时执行期添加的class 默认 isRun
					activeClass: 'isRun',
					//自定义倒计时期间文本的显示内容
					computeText(num) {
						//num 倒计时时间
						return '重新获取 ' + num + 's';
					},
					//是否可以发送
					canTodo: () => {
						//返回值判定是否可以发送
						let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
						console.log('判断是否可以发送验证码', result);
						if (!result) {
							alert('手机号格式不正确');
						}
						return result;
					},
					//canTode验证成功后执行 发送短信验证码
					todo: () => {
						//这里写验证码的获取程序
            console.log('发送验证码')
            getResetPwdSend({
              phone:this.phone
            }).then(res=>{
              this.$message.success('短信发送成功')
              console.log('发送短信',res)
            })
						//同时手机号不可改变了
						this.readonly = true
					},
					//发送完成后的回调
					endCallback(type, config) {
						//type 回调产生原因  0: 时间结束   其他值由this.$refs.geCode.stop(1)调入自定义
						//config config配置
						console.log('发送完成后的回调', type, config);
						//同时手机号可改变了
						this.readonly = false
					},
					//每次点击都会被调用
					click(isRun) {
						//isRun 是否在运行中
						console.log(`当前验证码状态是:${isRun ? '发送中' : '可发送'}状态`)
					},
					//是否可用   默认ture
					canUse: true,
					//不可用时的类名  默认no-can
					noCanClass: 'no-can',
				},
			}
		},
		mounted() {


		},
		computed: {
			showSendSms() {
				let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
				console.log("验证码", result)
				return result
			}
		},

		methods: {
			sendCode() {
				this.$refs.timerbtn.setDisabled(true); //设置按钮不可用

			},
			onPrev(){
				this.stepActive = 1
			},
			register(i) {
				this.stepActive = i || 2
        this.getResetPwdSendConfirmFun()
			},
      getResetPwdSendConfirmFun(i) {
        getResetPwdSendConfirm({
          phone:this.phone,
          code:this.code
        }).then(res=>{
          console.log('重置密码确认后返回',res)
          if (!res.success){
            this.$message.error(res.msg)
          }else{
            this.$message.success('密码重置成功')
          }
        }).catch(e=>{
          this.$message.error('验证码错误')
        })
			}
		},


	}
</script>

<style lang="less" scoped>
	@import '@/assets/reg.less';
	.city-selects{
		width: 450px;
	}
	.city-select{
		width: 160px;

	}
	.city-select+.city-select{
		margin-left: 15px;
	}
	.btn-send-code{
		height: 50px;
		margin-left: 15px;line-height: 50px;
		span{
			height: 50px;line-height: 50px;
		}
	}
	.el-upload__tip{
		padding: 10px 0;
	}


	/*复选框换成图片*/
	.checkboxStyle-small {
	  display: inline-block;
	  cursor: pointer;
	}
	.checkboxStyle-small input[type="checkbox"] {
	  appearance: none;
	  -webkit-appearance: none;
	  outline: none;
	  display: none;
	}
	.checkboxStyle-small input[type="checkbox"]:disabled + span {
	  opacity: .4;  position: relative;
	  top: -1px;
	}
	.checkboxStyle-small input[type="checkbox"] + span {
	  width: 13px;
	  height: 13px;
	  display: inline-block;
	  position: relative;
	  top: -1px;
	  background: url('../assets/company-default.png') no-repeat -725px -10px;
	  vertical-align: text-bottom;
	}
	.checkboxStyle-small input[type="checkbox"]:checked + span {
	  background-position: -725px -24px;
	}
	.personal-register .btn {
	    height: 50px;
	    line-height: 50px;
	    width: 40%;
	    border-radius: 20px;
	    font-size: 22px;
	}
	.personal-register .btn.default {
	    background: #fff;
	    color: @l;
	    border: 1px solid @l;
	    width: 25%;
	}
	.personal-register .btn + .btn {
	    margin-left: 20px;
	}
	.personal-register3{
		text-align: center;
		padding: 25px 0 20vh;
		font-size: 22px;
		a{
			color: @L;
			text-decoration: underline;
		}
	}
</style>
<style lang="less">
	.personal-register{


		.el-upload{
			display: block;
		}
		.el-upload-dragger{
			width: 450px;
			border-radius: 0;
		}

	}

</style>
